<template>
	<div class="z-30 relative">
		<div class="floating-whatsapp-btn right-[5px] lg:right-[20px] drop-shadow-lg mb-[20px]" @click="toggleModal">
			<img src="/images/whatsapp-icon.png" class="w-[45px] h-[45px] mr-[2px]" />
		</div>
		<transition name="fade">
			<div class="whatsapp-popup right-[5px] lg:right-[20px] drop-shadow-lg mb-[15px]" v-if="isFloatingWhatsAppActive">
				<div class="headerwhatsapp bg-siteRed-100 flex flex-row items-center justify-between">
					<div class="flex flex-row items-center space-x-2 text-white leading-none">
						<img src="/images/icon-whatsapp.png" class="w-8 h-8 mr-3" />
						<div class="text-lg lg:text-xl font-bold uppercase">Let us help you</div>
					</div>
					<div class="close-btn text-white" @click="toggleModal(); updateWhatsappClose()">
						&times;
					</div>
				</div>
				<div class="message-box-wrapper">
					<div class="inner-message-box bg-white px-2 rounded-b-xl py-4 md:pt-8 space-y-3 md:space-y-6">
						<div class="message-box text-left">
							<div class="message-text w-11/12 md:w-3/4 lg:w-4/5 bg-gray-100 font-normal">
                            	<p>Need to schedule an appointment with Dr Vanessa?</p>
							</div>
						</div>
						<div class="message-box text-right ml-auto w-10/12 sm:w-6/12 md:w-3/5 lg:w-2/3 xl:w-3/5">
							<a href="https://wa.me/+6586490280?text=I would like to schedule an appointment on…" class="items-center w-auto message-text font-normal bg-black hover:bg-gray-900 text-white flex" target="_blank">
								Click to WhatsApp us
								<img src="/images/message.png" class="ml-3 w-5 h-5" />
							</a>
						</div>
					</div>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
export default {
	data () {
		return {
			isFloatingWhatsAppActive: false,
			isFloatingWhatsAppTriggered: false,
		}
	},
	methods: {
		toggleModal() {
			this.isFloatingWhatsAppActive = !this.isFloatingWhatsAppActive
		},
		handleScroll () {
			if(!this.isFloatingWhatsAppTriggered) {
				if (window.scrollY >= 2000) {
					this.toggleModal()
					this.isFloatingWhatsAppTriggered = true
				}
			}
		},
		updateWhatsappClose() {
			if(this.isWhatsappIsClose != 1) {
					maxAge: 60 * 60 * 24
			}
		}
	},
	created () {
        if (process.client) {
        }
    },
    destroyed () {
        if (process.client) { 
        }
    },
	mounted() {
		if(this.isWhatsappIsClose != 1) {
			setTimeout(() => this.toggleModal(), 5000);
		}
	}
}
</script>

<style>
.fade-enter-active, .fade-leave-active {
	transition: opacity 0.25s;
}

.fade-enter, .fade-leave-to {
	opacity: 0;
}

.whatsapp-popup {
	position: fixed;
	bottom: 0px;
	width: 85%;
	z-index: 8;
}

@media (min-width: 768px) {
	.whatsapp-popup {
		width: 420px;
	}
}

.whatsapp-popup .headerwhatsapp {
	color: white;
	border-top-left-radius: 0.75rem;
	border-top-right-radius: 0.75rem;
	padding: 15px 20px;
	font-size: 22px;
}

@media (min-width: 768px) {
	.whatsapp-popup .headerwhatsapp {
		font-size: 24px;
		padding: 16px 16px;
	}
}

.whatsapp-popup .close-btn {
	cursor: pointer;
	justify-self: end;
	text-align: center;
	border-radius: 9999px;
	width: 36px;
	height: 36px;
	line-height: 36px;
	font-size: 24px;
}

.whatsapp-popup .message-box-wrapper {
	padding-left: 1rem;
	padding-right: 1rem;
	padding-bottom: 0;
	background-color: #f3f4f6;
	border-bottom-left-radius: 0.75rem;
	border-bottom-right-radius: 0.75rem;
}

@media (min-width: 768px) {
	.whatsapp-popup .message-box-wrapper {
		padding-left: 1rem;
		padding-right: 1rem;
		padding-bottom: 1rem;
	}
}

.whatsapp-popup .message-text {
	display: flex;
	padding: 1rem;
	border-radius: 1rem;
	font-size: 14px;
}

@media (min-width: 768px) {
	.whatsapp-popup .message-text {
		font-size: 16px;
	}
}

.floating-whatsapp-btn {
	position: fixed;
	cursor: pointer;
	display: flex;
	align-items: center;
	bottom: 0px;
	z-index: 7;
}
</style>
